// extracted by mini-css-extract-plugin
export var skipAnimation = "_r-0";